export default __webpack_public_path__ + "static/media/tempoIconWhite.5cc1687e.png";